import { motion } from 'framer-motion'
import { HiMail, HiPhone } from 'react-icons/hi'
import { useScrollToSection } from '@/hooks/useScrollToSection'
import { useLanguage } from '@/i18n/LanguageContext'

const EMAIL = 'comercial@envprocess.com'
const PHONE = '(11) 96821-4305'
const PHONE2 = '(11) 92507-9542'
const PHONE3 = '(351) 939 453 739'

const SITE = 'https://www.envprocess.com'

export function Footer() {
  const scrollTo = useScrollToSection()
  const { t } = useLanguage()

  const quickLinks = [
    { id: 'sobre', label: t.footer.quickLinks.sobre },
    { id: 'servicos', label: t.footer.quickLinks.servicos },
    { id: 'diferenciais', label: t.footer.quickLinks.diferenciais },
    { id: 'tecnologias', label: t.footer.quickLinks.tecnologias },
    { id: 'contato', label: t.footer.quickLinks.contato },
  ]

  return (
    <footer className="relative overflow-hidden text-slate-300">
      <div
        className="absolute inset-0 bg-[url('/envprocess-background-footer.png')] bg-no-repeat bg-cover bg-center"
        aria-hidden="true"
      />
      <div className="relative z-10 container-custom py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <a
              href={SITE}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent rounded-sm"
              aria-label="EnvProcess — www.envprocess.com"
            >
              <img
                src="/logo.png"
                alt="EnvProcess — Software Developer System"
                className="w-[132px] sm:w-[148px] md:w-[160px] h-auto object-contain object-left"
                width={160}
                height={48}
              />
            </a>
            <p className="mt-4 text-slate-400 leading-relaxed max-w-md">
              {t.footer.description}
            </p>
          </motion.div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
              {t.footer.quickLinksTitle}
            </h4>
            <ul className="mt-4 space-y-2">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
              {t.footer.contactTitle}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <HiMail className="h-4 w-4 shrink-0" />
                  {EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PHONE.replace(/\D/g, '')}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <HiPhone className="h-4 w-4 shrink-0" />
                  {PHONE}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PHONE2.replace(/\D/g, '')}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <HiPhone className="h-4 w-4 shrink-0" />
                  {PHONE2}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PHONE3.replace(/\D/g, '')}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <HiPhone className="h-4 w-4 shrink-0" />
                  {PHONE3}
                </a>
              </li>
              
            </ul>
            {/* Preparado para redes sociais */}
            {/* <div className="mt-4 flex gap-4">
              <a href="#" aria-label="LinkedIn">...</a>
              <a href="#" aria-label="Instagram">...</a>
            </div> */}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-700/60 text-center text-slate-500 text-sm">
          <p>
            © {new Date().getFullYear()} EnvProcess. {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  )
}
